module.exports = __webpack_public_path__ + "img/404.1bc3c9f7.png";